import { Service } from "../shared/Service";

export class EmpresaService extends Service{

  constructor(){
    super('empresa');
  }

}